export default __webpack_public_path__ + "static/media/pod_benefits.91ac27eb.png";